export default __webpack_public_path__ + "static/media/cesto_zucchine.504ad5ba.svg";